import gql from 'graphql-tag';

export const pagesQuery = gql`
  fragment Photos on WWS_Photo {
    mediaUrl
    mediaApiId
    width
    height
    cropX
    cropY
    rotation
    aspectRatio {
      name
      value
    }
  }

  fragment BasicItems on WWS_BasicItem {
    id
    description
    title
    rank
    type
    photo {
      ...Photos
    }
  }

  fragment StoryItems on WWS_StoryItem {
    id
    description
    title
    rank
    type
    photo {
      ...Photos
    }
  }

  fragment HeadlineItems on WWS_HeadlineItem {
    id
    title
    type
    style
    rank
  }

  fragment PhotoGalleryItems on WWS_PhotoGalleryItem {
    id
    layout
    photoItems {
      ...PhotoItems
    }
    rank
    type
  }

  fragment PhotoTimelineItems on WWS_PhotoTimelineItem {
    id
    layout
    photoItems {
      ...PhotoItems
    }
    rank
    type
  }

  fragment ParagraphItems on WWS_ParagraphItem {
    id
    content
    textContent
    type
    rank
  }

  fragment PersonItems on WWS_PersonItem {
    id
    type
    name
    description
    role
    rank
    photo {
      ...Photos
    }
  }

  fragment AccommodationItems on WWS_AccommodationItem {
    id
    email
    rank
    type
    description
    name
    phone
    website
    address
    guestCode
    rate
    checkInDate
    checkOutDate
    hotelPlannerId
    hotelId
    provider
    photo {
      ...Photos
    }
  }

  fragment ActivityItems on WWS_ActivityItem {
    id
    rank
    type
    phone
    description
    email
    phone
    website
    address
    name
    photo {
      ...Photos
    }
  }

  fragment TransportationItems on WWS_TransportationItem {
    id
    rank
    type
    name
    phone
    address
    website
    description
    email
    photo {
      ...Photos
    }
  }

  fragment PhotoItems on WWS_PhotoItem {
    id
    cropX
    cropY
    height
    mediaApiId
    mediaUrl
    rank
    rotation
    type
    width
    date
    caption
    aspectRatio {
      name
      value
    }
  }

  fragment CoverPhotoItems on WWS_CoverPhotoItem {
    id
    cropX
    cropY
    focalPoint
    height
    mediaApiId
    mediaUrl
    rank
    rotation
    type
    width
    date
    caption
    aspectRatio {
      name
      value
    }
  }

  fragment EventGroupItem on WWS_EventGroupItem {
    id
    rank
    type
  }

  fragment GifItems on WWS_GifItem {
    id
    rank
    type
    mediaUrl
  }

  fragment EmbedItems on WWS_EmbedItem {
    id
    rank
    type
    title
    description
    embededCode
    mediaService
  }

  fragment QuestionItems on WWS_QuestionItem {
    id
    rank
    type
    question
    answer
  }

  fragment LivestreamItems on WWS_LivestreamItem {
    id
    rank
    type
    title
    description
    buttonText
    buttonUrl
  }

  fragment DressCodeItems on WWS_DressCodeItem {
    id
    rank
    type
    description
    attireCategoryId
    attireDescription
    eventId
    showArticles
    showAffiliates
    articles {
      url
      imageUrl
      title
    }
  }

  fragment Pages on WWS_Page {
    id
    title
    rank
    show
    type
    pageGuidance {
      visiblePageDescription
      hiddenPageDescription
    }
    pageItemTypes
    pageItemGuidances {
      type
      icon
      ctaText
      image {
        mediaApiId
      }
    }
    routeName
    supportedImageTypes {
      name
      defaultAspectRatio {
        name
        value
      }
      aspectRatios {
        name
        value
      }
    }
    items {
      id
      rank
      type
      ...BasicItems
      ...StoryItems
      ...HeadlineItems
      ...AccommodationItems
      ...ActivityItems
      ...TransportationItems
      ...ParagraphItems
      ...PersonItems
      ...PhotoItems
      ...PhotoGalleryItems
      ...PhotoTimelineItems
      ...EventGroupItem
      ...GifItems
      ...EmbedItems
      ...QuestionItems
      ...LivestreamItems
      ...DressCodeItems
      ...CoverPhotoItems
    }
  }

  query pagesQuery {
    pages {
      ...Pages
    }
  }
`;
